<!DOCTYPE html>
@if (defaultBackgroundSet) {
  <div class="temp-bg fallback-background"></div>
}
<ng-lottie
  [options]="options"
  loop="false"
  speed="0.1"
  class="custom-level-feed-animation"
  [ngClass]="imageLoadFailed ? 'fallback-background' : ''"
  (dataReady)="onLoopComplete()"
></ng-lottie>
